import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody } from 'reactstrap';
import InputGroup from '../../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../../components/cms/form/submitButtons';

const SyncAnimation = ({
  t,
  onSubmit,
  isSubmitting,
  isSubmittingRedirect,
  onChange,
  formData,
}) => (
  <div>
    <Card>
      <CardHeader>
        <strong><i className="fa fa-flag-o" /> {t('Update animation uploaded by FPT')}</strong>
      </CardHeader>
      <CardBody>
        <InputGroup
          name="pathToAnimation"
          label={t('Path to animation')}
          onChange={onChange}
          value={formData.pathToAnimation}
          icon="fa fa-folder-o"
        />
        <SubmitButtons
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
          showSaveButton={false}
          applyText={t('Sync animation')}
          defaultApplyClassName="fa fa-paper-plane mr-2"
          isSubmittingRedirect={isSubmittingRedirect}
        />

        <div className="small-desc">
          <small>
            Examples: <br/>
            1/1TESTRIG9_1_4X5<br/>
            /debug/1TESTRIG9_1_4X5/<br/>
            /music/1TESTRIG9_1_template/<br/>
            /112/1TESTRIG9_1_template<br/>
          </small>
        </div>
      </CardBody>
    </Card>
  </div>
);

SyncAnimation.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
};

export default SyncAnimation;



// WEBPACK FOOTER //
// ./src/views/settings/components/syncAnimation/SyncAnimation.jsx